import { Component, Input, OnInit } from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
import { RepriseHelperService } from '@shared/services/reprise-helper.service';
import { RouterHelperService } from '@shared/services/router-helper.service';

@Component({
    selector: 'app-steps-adhesion-modal',
    templateUrl: './steps-adhesion-modal.component.html',
    animations: modalAnimations,
    styleUrls: ['./steps-adhesion-modal.component.scss'],
})
export class StepsAdhesionModalComponent implements OnInit {
    @Input() currentStepId: string;
    currentStepIndex: number;
    visibility: boolean;
    steps: any[];

    constructor(
        private repriseHelperService: RepriseHelperService,
        private routerHelperService: RouterHelperService
    ) {}

    ngOnInit(): void {
        this.steps = this.getInitialSteps();
        this.currentStepIndex = this.getStepIndexById(this.currentStepId);
        this.visibility =
            this.repriseHelperService.isStepsAdhesionModalNeedToBeDisplay();
    }

    public getInitialSteps(): any[] {
        if (this.routerHelperService.getTopSansSelectionMedicale()) {
            return [
                {
                    id: 'info_doc_download',
                    image: 'assets/images/info_doc_download.svg',
                    text: 'modal.welcome.info-doc-download',
                },
                {
                    id: 'signature_dad',
                    image: 'assets/images/sign_doc.svg',
                    text: 'modal.welcome.signature',
                },
                {
                    id: 'decision_assureur',
                    image: 'assets/images/decision.svg',
                    text: 'modal.welcome.contrat',
                },
            ];
        }
        return [
            {
                id: 'qs',
                image: 'assets/images/health_book.svg',
                text: 'modal.welcome.medicalworkflow',
            },
            {
                id: 'signature_dad',
                image: 'assets/images/sign_doc.svg',
                text: 'modal.welcome.signature',
            },
            {
                id: 'etude_dossier',
                image: 'assets/images/folder.svg',
                text: 'adhesion.stepper.document-selection',
            },
            {
                id: 'decision_assureur',
                image: 'assets/images/decision.svg',
                text: 'modal.welcome.contrat',
            },
        ];
    }

    public getStepIndexById(stepId: string): number {
        return this.steps.findIndex((step) => step.id === stepId);
    }
}
